import { render, staticRenderFns } from "./MypageFavoritePlayerLinkSection.vue?vue&type=template&id=6d51ac8d&scoped=true"
import script from "./MypageFavoritePlayerLinkSection.vue?vue&type=script&lang=ts"
export * from "./MypageFavoritePlayerLinkSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageFavoritePlayerLinkSection.vue?vue&type=style&index=0&id=6d51ac8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51ac8d",
  null
  
)

export default component.exports